var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.06 8.94L5 8L7.06 7.06L8 5L8.94 7.06L11 8L8.94 8.94L8 11L7.06 8.94ZM8 21L8.94 18.94L11 18L8.94 17.06L8 15L7.06 17.06L5 18L7.06 18.94L8 21ZM4.37 12.37L3 13L4.37 13.63L5 15L5.63 13.63L7 13L5.63 12.37L5 11L4.37 12.37ZM12 12C12 9.27 13.08 6.73 14.75 4.75L12 2H19V9L16.18 6.18C14.84 7.82 14 9.88 14 12C14 15.32 16.1 18.36 19 19.82V22C14.91 20.41 12 16.35 12 12Z",
    fill: "#2DA189"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/switch.0114fc435a7feb8673aa3a2feabd4455.svg";
export { ForwardRef as ReactComponent };